export default {"src":"/_next/static/media/win-win.6a339593.svg","height":135,"width":144};